const grouplist = {
  state: {
    requestNums: 0, // 消息数
  },
  mutations: {
    // 设置消息数
    setRequestNums(state, payload){
      state.requestNums = payload
    },
  },
  actions: {}
}

export default grouplist